<template>
  <div class="historicalModelManagement-page">
    <div class="all-content-container">
      <div class="content-left-container">
        <!-- <el-image
      style="width: 100px; height: 100px"
      src="@/assets/img/u1367.png"
        :fit="fit"></el-image>-->
        <img src="@/assets/img/u1367.png" alt />
      </div>
      <div class="content-right-container">
        <div class="content-callback-btn">
          <el-link   :underline="false" @click="back_go"><i class="el-icon-caret-left"></i>返回</el-link>
        </div>
        <div class="table-content-container">
          <div class="table-title-container">
            <h4>历史模型</h4>
          </div>
          <div class="table-content">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column align="center" prop="name" label="模型名称"></el-table-column>
              <el-table-column align="center" prop="userName" label="创建人"></el-table-column>
              <el-table-column align="center" prop="updateTime" label="创建时间"></el-table-column>
              <el-table-column label="操作" align="center">
                <el-link type="primary" :underline="false">查看模型</el-link>
              </el-table-column>
            </el-table>
              <div class="pagination-container">
         
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev,pager,next,jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pagesize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"historicalModelManagement",
  data() {
    return {
      currentPage:1,
      pagesize:10,
      total:1,
      tableData: [
        
      ]
    };
  },
  created() {
      this.init()
  },
  methods:{
    back_go(){
      this.$router.push({
        path:'growthStageManagement'
         
 })
    },
    //数据请求函数
    init (){
 this.getHisGrowthModelList()
    },
    //分页
    handleCurrentChange(currentPage){
      this.currentPage=currentPage
      this.getHisGrowthModelList()

    },
    //查询历史生长模型列表
    getHisGrowthModelList(){
       this.$api.system
        .getHisGrowthModelList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.cropId, //作物id
          this.id, // 主键id ，根据具体业务进
          this.remark, //图片
          this.name ,//名称
          this.updateId,//创建修改人员id
          this.updateTime,//创建修改时间
        )
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/historicalModelManagement.scss";
</style>